import { useEffect, useReducer, useState } from "react";
import {
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Button,
} from "reactstrap";
import { getCheckPanel, updateCheckPanel } from "../../services/checkerPanel.service";
import { toast } from "react-hot-toast";
import FormInput from "../../components/FormInput";
import { Formik, getIn } from "formik";
import * as Yup from "yup";

const initialState = {
  results: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  totalResults: 0,
  startIndex: 1,
  endIndex: 10,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case "SET_DATA":
      return action.payload;
    default:
      return state;
  }
}

function CheckerPanel() {
  const [data, dispatch] = useReducer(reducer, initialState);
  const [holdModal, setHoldModal] = useState(false);
  const [stopModal, setStopModal] = useState(false);
  const [pickList, setPickList] = useState<any>(null);

  const toggleHold = () => setHoldModal(!holdModal);

  const toggleStop = () => setStopModal(!stopModal);

  const setData = (data: any) => {
    dispatch({ type: "SET_DATA", payload: data });
  };
  useEffect(() => {
    getCheckPanel({ page: 1 }).then((response: any) => {
      setData(response.data);
    });
  }, []);

  const updateResults = (id: any, updatedObject: any, response: any) => {
    let updatedResults = data.results;
    if (updatedObject.status === "STOPPED") {
      updatedResults = updatedResults.filter((pickList: any) => pickList.id !== id);
    } else {
      updatedResults = updatedResults.map((pickList: any) => {
        if (pickList.id === id) {
          return { ...pickList, ...response.data };
        }
        return pickList;
      });
    }
    setData({ ...data, results: updatedResults });
  };

  const handleClick = (id: any, updatedObject: any) => {
    return updateCheckPanel(id, updatedObject)
      .then((response: any) => {
        updateResults(id, updatedObject, response);
      })
      .catch((error) => {
        toast.error(error.response.data.message);
      });
  };

  const handleHoldSubmit = (id: any, updatedObject: any) => {
    handleClick(id, updatedObject).then(() => {
      toggleHold();
    });
  };

  const handleStopSubmit = (id: any, updatedObject: any) => {
    handleClick(id, updatedObject).then(() => {
      toggleStop();
    });
  };

  return (
    <div className='d-flex flex-column h-100 px-sm-1 w-100 pb-sm-1'>
      <Row className='align-items-center mb-2'>
        <Col sm>
          <h1 className='my-1 fw-bold h4'>Checker Panel</h1>
        </Col>
      </Row>

      <Row>
        {data.results.map((pickList: any) => (
          <Col className='mb-4' md={3} key={pickList.id}>
            <Card
              className='text-white'
              color='primary'
              // className='my-2'
              // style={{
              //   width: "18rem",
              // }}
            >
              <CardBody>
                <CardTitle tag='h6'>{pickList.orderNumber}</CardTitle>
                <CardText>
                  <div className='text-end'>{pickList.party?.name || ""}</div>

                  <div className='d-flex justify-content-between '>
                    {(pickList.status === "PENDING" || pickList.status === "HOLD") && (
                      <div>
                        <button
                          className='text-center'
                          onClick={() => {
                            handleClick(pickList.id, { status: "STARTED" });
                          }}
                        >
                          Start
                        </button>
                      </div>
                    )}
                    {pickList.status === "STARTED" && (
                      <>
                        <button
                          onClick={() => {
                            toggleHold();
                            setPickList(pickList);
                          }}
                        >
                          Hold
                        </button>
                        <button
                          onClick={() => {
                            toggleStop();
                            setPickList(pickList);
                          }}
                        >
                          Stop
                        </button>
                      </>
                    )}
                  </div>
                </CardText>
              </CardBody>
            </Card>
          </Col>
        ))}
      </Row>
      {/* Hold Modal */}
      <Modal isOpen={holdModal} toggle={toggleHold}>
        <ModalHeader toggle={toggleHold}>Fill the details</ModalHeader>

        <Formik
          initialValues={{
            comment: "",
          }}
          validationSchema={Yup.object().shape({
            comment: Yup.string().required("Comment is required."),
          })}
          onSubmit={(values) => {
            handleHoldSubmit(pickList.id, {
              status: "HOLD",
              comment: values.comment,
            });
          }}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
            <>
              <ModalBody>
                <FormInput
                  label='Comment'
                  name='comment'
                  type='textarea'
                  rows='8'
                  cols='50'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={getIn(values, "comment")}
                  error={getIn(errors, "comment")}
                  touched={getIn(touched, "comment")}
                />
              </ModalBody>
              <ModalFooter>
                <Button
                  size='sm'
                  color='primary'
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>{" "}
                <Button size='sm' color='secondary' onClick={toggleHold}>
                  Cancel
                </Button>
              </ModalFooter>
            </>
          )}
        </Formik>
      </Modal>
      {/* Stop Modal */}
      <Modal isOpen={stopModal} toggle={toggleStop}>
        <ModalHeader toggle={toggleStop}>Fill the details</ModalHeader>

        <Formik
          initialValues={{
            numberOfBox: null,
          }}
          validationSchema={Yup.object().shape({
            numberOfBox: Yup.number().required("Number of Box is required."),
          })}
          onSubmit={(values) => {
            handleStopSubmit(pickList.id, {
              status: "STOPPED",
              numberOfBox: values.numberOfBox,
            });
          }}
        >
          {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
            <>
              <ModalBody>
                <FormInput
                  label='Number of Box'
                  name='numberOfBox'
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={getIn(values, "numberOfBox")}
                  error={getIn(errors, "numberOfBox")}
                  touched={getIn(touched, "numberOfBox")}
                />
              </ModalBody>
              <ModalFooter>
                <Button
                  size='sm'
                  color='primary'
                  onClick={() => {
                    handleSubmit();
                  }}
                >
                  Submit
                </Button>{" "}
                <Button size='sm' color='secondary' onClick={toggleStop}>
                  Cancel
                </Button>
              </ModalFooter>
            </>
          )}
        </Formik>
      </Modal>
    </div>
  );
}

export default CheckerPanel;
